import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface ISaleListDetail {
    id: string;
    code: string;
    addAmount?: string,   // 0
    batches?: string,   // "0"
    bentityCode?: string,   // "bentity.yhcy"
    bentityName?: string,   // "云湖春煜（天津）资产管理有限公司"
    contact?: string,   // "摩托车"
    contractAmount?: string,   // 0
    countryCode?: string,   // "country.ethiopia"
    countryName?: string,   // "Ethiopia 埃塞俄比亚"
    createTime?: string,   // "2022-05-10 11:40:57"
    createUser?: string,   // "庞愿领"
    currencyCode?: string,   // "gtm.currency.cny"
    currencyName?: string,   // "CNY"
    customerCode?: string,   // "CUS-M-00018678"
    customerId?: string,   // "671c63263b8b3a8324fc947f42b3edd6"
    customerName?: string,   // "看见我的客户了吗"
    deleteFlag?: string,   // 0
    exchangeRate?: string,   // "6.188"
    goodsAmount?: string,   // 0
    gtmAmount?: string,   // 0
    oceanFreight?: string,   // 0
    offerCode?: string,   // "B-motuo-2201"
    orderNum?: string,   // 0
    payStatus?: string,   // "pay-status.init"
    phone?: string,   // "1530035515"
    relevanceOrderId?: string,   // "086bdca3a7964dddb8a0a06ee53142d5"
    rmbAmount?: string,   // 0
    shopCode?: string,   // "SHOP-M-00000102"
    shopName?: string,   // "云湖门店"
    status?: string,   // "sales.init"
    transship?: string,   // "0"
    typeNum?: string,   // 3
    updateTime?: string,   // "2022-05-10 11:40:56"
    currency?: string,   // "2022-05-10 11:40:56"
    offerTime?: string,   // "2022-05-10 11:40:56"
}

//新增
export interface ISaleListInsert extends ISaleListDetail { }

//编辑
export interface ISaleListUpdate extends ISaleListInsert {
    id: string;
}

//搜索条件
export interface ISaleListSearchFields {
    customerName?: string,
    code?: string,
    startTime?: string,
    endTime?: string,
}

export interface ISaleListSearch extends ISaleListSearchFields, ISearchPage { }

export interface IStatistics { num: number, amount: number }

class SaleListService {
    async page(searchVo: ISaleListSearch, config: object = {}) {
        const apiUrl = "/gtm/standingBooking/saleListPage";
        return await httpRequest.post<IPage<ISaleListDetail>>(apiUrl, searchVo, config);
    }
    async total(searchVo: ISaleListSearch, config: object = {}) {
        const apiUrl = "/gtm/standingBooking/saleListPage/total";
        return await httpRequest.post<IStatistics>(apiUrl, searchVo, config);
    }

    //导出
    async export(searchVo: ISaleListSearch) {
        const appPageUrl = "/gtm/standingBooking/saleListPage/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/sale/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

}

export const saleListService = new SaleListService();
